// extracted by mini-css-extract-plugin
export default {"title":"K--z","warning":"L--z","sizeOptionsLegendText":"M--z"};